import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchLoanAccountList } from '../../actions/TeleAgentAction';
import AccountActionContainer from '../../components/Accounts/AccountActionContainer';
import AccountDetailsForTeleAgent from '../../components/TeleAgent/TeleAgentManual/AccountDetailsForTeleAgent';
import { default as AdditionDetails } from '../../components/TeleAgent/TeleAgentManual/AdditionDetails';
import AddressDetails from '../../components/TeleAgent/TeleAgentManual/AddressDetails';
import ContactDetails from '../../components/TeleAgent/TeleAgentManual/ContactDetails';
import LoanDetails from '../../components/TeleAgent/TeleAgentManual/LoanDetails';
import PaymentHistoryDetails from '../../components/TeleAgent/TeleAgentManual/PaymentHistoryDetails';
import VegaBreadCrumb from '../../components/common/VegaBreadCrumb';
import VegaPageContent from '../../components/common/VegaPageContent';
import VegaPageHeader from '../../components/common/VegaPageHeader';
import { useAppDispatch } from '../../store';
import PendingDuesDetails from '../../components/TeleAgent/TeleAgentManual/PendingDuesDetails';
import LegalActionDetails from '../../components/TeleAgent/TeleAgentManual/LegalActionDetails';
import {
  fetchArbitationDeatils,
  fetchSarfaesiMisDeatils,
  fetchSecDeatils,
} from '../../features/legalSlice';
import LinkedAccountDetails from '../../components/TeleAgent/TeleAgentManual/LinkedAccountDetails';

const AccountDetails = () => {
  const { loanAccountId } = useParams();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (loanAccountId) {
      dispatch(
        fetchLoanAccountList({
          loanId: loanAccountId,
          includeCustomerDetails: true,
          includeLmsVariables: true,
          includeLoanOutstandingDetails: true,
          includeLoanTransactions: true,
          includeLoanPdcDetails: true,
          restrictedView: true,
          includeMetaDataLoanAllocation: true,
        })
      );
      dispatch(
        fetchSarfaesiMisDeatils({ caseTypeId: '1', lanNo: loanAccountId })
      );
      dispatch(
        fetchArbitationDeatils({ caseTypeId: '5', lanNo: loanAccountId })
      );
      dispatch(fetchSecDeatils({ caseTypeId: '4', lanNo: loanAccountId }));
    }
  }, [dispatch]);

  return (
    <>
      <VegaPageHeader
        sx={{ borderBottom: 'none', bgcolor: 'transparent' }}
        renderLeftView={() => {
          return (
            <VegaBreadCrumb
              items={[
                { label: 'My Account', link: -1 },
                { label: `Account Details` },
              ]}
            />
          );
        }}
      />
      <AccountDetailsForTeleAgent />
      <AccountActionContainer />
      <VegaPageContent sx={{ pt: '1rem' }}>
        <Box
          sx={{
            p: '1rem',
            bgcolor: 'white',
            borderRadius: '0.75rem',
            border: '1px solid #E1E4EB',
            my: '1rem',
          }}
        >
          <Stack gap={2}>
            <LoanDetails />
            <PaymentHistoryDetails />
            <PendingDuesDetails />
            <AddressDetails />
            <ContactDetails />
            <AdditionDetails />
            <LinkedAccountDetails />
            <LegalActionDetails />
          </Stack>
        </Box>
      </VegaPageContent>
    </>
  );
};

export default AccountDetails;
